<template>
  <div class="row justify-content-between mt-3 mb-4">
    <div class="col-md-10">
      <div class="white-card mr-0 p-3">
        <div class="d-flex mb-0 align-items-center justify-content-end">
          <help-icon class="mr-2" size="18"/>
          <span>{{ $t('info.none.tva.insurance') }}</span>
        </div>

        <b-form v-unsave-detector @submit.stop.prevent="onSubmit">

          <template v-for="operationCharge in operationCharges">
            <operation-charge-component
              :is-h-t="isHT"
              :operation-charge="operationCharge"
              @didChangeValue="emitChangeValue"
              @removedOperationCharge="removedOperationCharge"/>
          </template>

          <div class="row mt-3">
            <div class="col-md-12">
              <span class="bold-text addLink"
                    @click="addOperationCharge()"> + {{ $t('Add') }} {{ $t(typeFrais.text) }}</span>
            </div>
          </div>

          <div class="d-flex justify-content-end">
            <b-button class="mr-3" variant="outline-primary" @click="back">{{ $t('Back') }}</b-button>
            <b-button type="submit" variant="primary">{{ $t('Save.and.Continue') }}</b-button>
          </div>

        </b-form>
      </div>
    </div>

    <div class="col-md-2">
      <OperationBilanCardPrice
        :prices="totalPrices">
      </OperationBilanCardPrice>
    </div>

    <add-operation-charge-modal
      :type-frais="typeFrais"
      :operation-id="operationId"
      :existing-pourcentage-prix-revient-count="existingPourcentagePrixRevientCount"
      :is-h-t="isHT"
      @didAddOperationCharge="didAddOperationCharge"/>

  </div>

</template>

<script>
import OperationBilanCardPrice from "./components/OperationBilanCardPrice.vue";
import OperationChargeComponent from "../components/OperationChargeComponent";
import AddOperationChargeModal from "../components/AddOperationChargeModal";
import api from "../../../services/api";

export default {
  name: "OperationBilanInsurances",

  components: {
    OperationBilanCardPrice,
    OperationChargeComponent,
    AddOperationChargeModal
  },

  props: {
    operationId: {
      type: Number,
      default: null
    },
    simulationId: {
      type: Number,
      default: null
    },
    isHT: {
      type: Boolean,
      default: false
    }
  },


  data() {
    return {
      operationBilanId: null,
      totalPrices: [],
      operationCharges: [],
      operationChargesIdsToRemove: [],
      typeFrais: null
    }
  },

  emits: ['didContinue', 'didBack', 'didChangeValue'],

  async mounted() {
    await this.fetchData()
  },

  methods: {
    async fetchData() {
      await this.getOperationBilanId()
      await this.getTotalOfBilan()
      await this.getTypeFrais()
      await this.getOperationCharges()
    },

    async getOperationBilanId() {
      await api
        .get(`/operation/getOperationBilanId/${this.operationId}`)
        .then(response => {
          this.operationBilanId = response.data.id
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 0,
                message: error.response.data.message
              }
            })
          }
        })
    },

    async getTypeFrais() {
      await api
        .get(`/operationCharge/getTypeInsurances`)
        .then(response => {
          this.typeFrais = response.data
        })
    },

    async getTotalOfBilan() {
      await api
        .get(`/operationBilan/getTotalOfBilan/${this.operationId}`)
        .then(response => {
          this.totalPrices = response.data
        })
    },

    async getOperationCharges() {
      if (this.operationId != null) {
        await api
          .get(`/operationCharge/getAllInsurancesForOperation/${this.operationId}`)
          .then(response => {
            this.operationCharges = (response.data || []).map(ch => ({
              ...ch,
              uniteCharge: ch.uniteCharge || ch.uniteChargeEnum || null,
              pourcentage: ch.pourcentage != null ? ch.pourcentage : null,
            }))
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'OperationShow',
                params: {
                  operationId: this.operationId,
                  currentSection: 1,
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },

    async emitChangeValue() {
      this.$emit('didChangeValue')
    },

    addOperationCharge() {
      this.$bvModal.show('add-operation-charge-modal')
    },

    didAddOperationCharge(operationCharge) {
      this.operationCharges.push(operationCharge)
    },

    removedOperationCharge(operationCharge) {
      if (operationCharge.id) {
        this.operationChargesIdsToRemove.push(operationCharge.id)
      }
      this.operationCharges.splice(this.operationCharges.indexOf(operationCharge), 1)
    },

    back() {
      this.$confirm(this.$i18n.t('Back.confirm').toString()).then(() => {
        this.$emit('didBack')
      });
    },

    async onSubmit() {
      await this.createOrUpdateOperationCharges()
      await this.deleteOperationCharges()
      await this.editOperationBilan()
      this.$emit('didContinue', this.operationId, this.operationBilanId)
    },

    async createOrUpdateOperationCharges() {
      for (const operationCharge of this.operationCharges) {
        let data = new FormData()
        data.append('operationId', this.operationId)
        data.append('name', operationCharge.name)
        data.append('prixTTC', operationCharge.prixTTC)

        if (operationCharge.uniteCharge) {
          data.append('uniteCharge', operationCharge.uniteCharge)
        }
        if (operationCharge.pourcentage != null && operationCharge.pourcentage !== '') {
          data.append('pourcentage', operationCharge.pourcentage)
        }
        data.append('typeFrais', operationCharge.typeFrais.value)

        let url = 'operationCharge'
        if (operationCharge.id) {
          url = '/operationCharge/' + operationCharge.id
        }

        await api({
          method: 'POST',
          url: url,
          data: data
        })
          .then(() => {
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'OperationShow',
                params: {
                  operationId: this.operationId,
                  currentSection: 1,
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },

    async deleteOperationCharges() {
      for (const operationChargeId of this.operationChargesIdsToRemove) {
        await api
          .delete(`/operationCharge/${operationChargeId}`)
      }
    },

    async editOperationBilan() {

      let data = new FormData()
      data.append('assurancesDone', true)

      api({
        method: 'POST',
        url: '/operationBilan/' + this.operationBilanId,
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    }
  },
  
  computed: {
    existingPourcentagePrixRevientCount() {
      try {
        return (this.operationCharges || []).filter(c => c && (c.uniteCharge === 'POURCENTAGE_PRIX_REVIENT' || c.uniteChargeEnum === 'POURCENTAGE_PRIX_REVIENT')).length
      } catch (e) {
        return 0
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationBilan/bilanCreateEditSteps/OperationBilanInsurances.vue